import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";

import App from "./App.jsx";
import "./index.css";
// import "../portfolio.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      {/* <ScrollToTop /> */}
      <App /> {/* Only wrap App with Router here */}
    </Router>
  </React.StrictMode>,
);
